
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 12","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.497 9.385a1.5 1.5 0 102.006 2.23L.497 9.385zM6.5 6l1.003 1.115a1.5 1.5 0 000-2.23L6.5 6zM2.503.385a1.5 1.5 0 00-2.006 2.23L2.503.385zm0 11.23l5-4.5-2.006-2.23-5 4.5 2.006 2.23zm5-6.73l-5-4.5-2.006 2.23 5 4.5 2.006-2.23z"}})])
          )
        }
      }
    